import { render, staticRenderFns } from "./DomainIpSettings.vue?vue&type=template&id=4436e51e&scoped=true&"
import script from "./DomainIpSettings.vue?vue&type=script&lang=js&"
export * from "./DomainIpSettings.vue?vue&type=script&lang=js&"
import style0 from "./DomainIpSettings.vue?vue&type=style&index=0&id=4436e51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436e51e",
  null
  
)

export default component.exports